export const MEDIA_PER_PAGE = Object.freeze({
  xs: 2,
  sm: 4,
  md: 4,
  lg: 7,
});

export const ICON_THEMES = Object.freeze({
  RATING: 'rating',
  MONEY: 'money',
  RECEIPT: 'receipt',
  LUNCH: 'lunch',
  MEETING: 'meeting',
  HOLIDAY: 'holiday',
  EXAM: 'exam',
  SICK_LEAVE: 'sick-leave',
  OTHER: 'other',
  INNEREXAM: 'innerexam',
  THEORY: 'theory',
  PLANMEETING: 'planmeeting',
});

export const ICONS_MAP = Object.freeze({
  [ICON_THEMES.MONEY]: 'coins',
  [ICON_THEMES.RECEIPT]: ICON_THEMES.RECEIPT,
  [ICON_THEMES.LUNCH]: 'cutlery',
  [ICON_THEMES.MEETING]: ICON_THEMES.MEETING,
  [ICON_THEMES.HOLIDAY]: 'holiday',
  [ICON_THEMES.EXAM]: 'exam',
  [ICON_THEMES.SICK_LEAVE]: 'medicine',
  [ICON_THEMES.OTHER]: 'lightning',
  [ICON_THEMES.INNEREXAM]: 'innerexam',
  [ICON_THEMES.THEORY]: 'lesson',
  [ICON_THEMES.PLANMEETING]: 'comment',
});

export const KEYS_MAP = Object.freeze({
  /* eslint-disable quote-props */
  'Обед': ICON_THEMES.LUNCH,
  'Собрание': ICON_THEMES.MEETING,
  'Отпуск': ICON_THEMES.HOLIDAY,
  'Гос. экзамен': ICON_THEMES.EXAM,
  'Больничный': ICON_THEMES.SICK_LEAVE,
  'Непредвиденные обстоятельства': ICON_THEMES.OTHER,
  'Занятие по теории': ICON_THEMES.THEORY,
  'Внутренний экзамен': ICON_THEMES.INNEREXAM,
  'Планерка': ICON_THEMES.PLANMEETING,
  /* eslint-enable quote-props */
});
